import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { LanguageContext } from "../App";

const SEO_DATA = {
  it: {
    lang: "it",
    title: "Hotel Aurora Duino – Hotel 3 stelle tra Trieste e il mare",
    description:
      "Boutique hotel 3 stelle a Duino Sistiana, tra Trieste e l'Adriatico. Camere di design con materassi Simmons, a 5 minuti dal Castello di Duino e dal Sentiero Rilke.",
    ogTitle: "Hotel Aurora Duino – Minimal design tra Trieste e il mare",
    ogDescription:
      "Scopri le camere Economy, Comfort e Superior. Wi-Fi, parcheggio, Smart TV, noleggio E-bike. Prenota direttamente sul sito.",
  },
  en: {
    lang: "en",
    title: "Hotel Aurora Duino – Minimal Design Hotel between Trieste and the Sea",
    description:
      "3-star boutique hotel in Duino Sistiana, between Trieste and the Adriatic Sea. Design rooms with Simmons mattresses, 5 minutes from Duino Castle and the Rilke Trail.",
    ogTitle: "Hotel Aurora Duino – Between Trieste and the Adriatic Sea",
    ogDescription:
      "Discover Economy, Comfort and Superior rooms. Wi-Fi, free parking, Smart TV, E-bike rental. Book directly on our website.",
  },
  de: {
    lang: "de",
    title: "Hotel Aurora Duino – Minimal Design Hotel zwischen Triest und dem Meer",
    description:
      "3-Sterne-Boutique-Hotel in Duino Sistiana, zwischen Triest und der Adria. Designzimmer mit Simmons-Matratzen, 5 Minuten vom Schloss Duino und dem Rilke-Pfad.",
    ogTitle: "Hotel Aurora Duino – Zwischen Triest und der Adria",
    ogDescription:
      "Entdecken Sie Economy-, Comfort- und Superior-Zimmer. WLAN, kostenloser Parkplatz, Smart TV, E-Bike-Verleih. Direkt auf unserer Website buchen.",
  },
  nl: {
    lang: "nl",
    title: "Hotel Aurora Duino – Designhotel tussen Triëst en de zee",
    description: "3-sterren boetiekhotel in Duino Sistiana, tussen Triëst en de Adriatische Zee. Designkamers met Simmons-matrassen, op 5 minuten van Kasteel Duino en het Rilke-pad.",
    ogTitle: "Hotel Aurora Duino – Design en rust aan de Adriatische Zee",
    ogDescription: "Ontdek Economy-, Comfort- en Superior-kamers. Wifi, gratis parkeren, Smart TV, e-bike verhuur. Direct boeken op onze website.",
  },
};

const OG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/1b339670-394f-4389-9bf2-fdd77eb8a0dd/images/f9eca9c87e439b789709bac1e5f71891e0ab4bb01ac9ed02b4d55cb3f1c22910.png";
const SITE_URL = "https://www.auroraduino.com";

export default function SEOMeta() {
  const { lang } = useContext(LanguageContext);
  const seo = SEO_DATA[lang] || SEO_DATA.en;

  return (
    <Helmet>
      {/* Base */}
      <html lang={seo.lang} />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={SITE_URL} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={SITE_URL} />
      <meta property="og:title" content={seo.ogTitle} />
      <meta property="og:description" content={seo.ogDescription} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={lang === "it" ? "it_IT" : lang === "de" ? "de_DE" : lang === "nl" ? "nl_NL" : "en_GB"} />
      {/* fallback for unknown lang */}
      {!SEO_DATA[lang] && <html lang="en" />}
      <meta property="og:site_name" content="Hotel Aurora Duino" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.ogTitle} />
      <meta name="twitter:description" content={seo.ogDescription} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {/* Geo */}
      <meta name="geo.region" content="IT-TS" />
      <meta name="geo.placename" content="Duino, Trieste" />
      <meta name="geo.position" content="45.7724;13.6169" />

      {/* Theme */}
      <meta name="theme-color" content="#FAFAFA" />
    </Helmet>
  );
}
